module.exports = __webpack_public_path__ + "images/orphaned_sku-ff24ef55.svg";